import moment from "moment";
import { FC, useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Input, Switch, Textarea } from "rizzui";
import { usePrivilege } from "../../../../components/priviledge/PriviledgeProvider";
import useFetch from "../../../../hooks/useFetch";
import FormGroup from "../../../../layout/shared/form-group";
import { IssueService } from "../../../../services/issue/issueService";
import { IssuesApiResponse } from "../../../../type/entities/issues-type";
import { age, carrionPresentSelector, cloudCover, sex, stateSpecies, windDirectionsSpanish, windSpeed, yesNoSelector } from "../../../../utils/SelectorMapping";

interface IssuesInfoProps {

}


const IssuesInfo: FC<IssuesInfoProps> = () => {

    // STATES 
    const [huso, setHuso] = useState<string>('');
    const [coordinatesX, setCoordinatesX] = useState<string>('');
    const [coordinatesY, setCoordinatesY] = useState<string>('');
    const [isProtected, setIsProtected] = useState<boolean>(false);
    const [isRefecth, setIsRefecth] = useState<boolean>(true);

    // HOOKS

    const { id = '' } = useParams<{ id: string }>();
    const service = new IssueService();
    const { userCan } = usePrivilege();


    // DATA FETCHING

    const [data, loading] = useFetch(useCallback(async () => {
        if (!id || id === '' || isRefecth == false) return null;
        if (isRefecth) setIsRefecth(false);
        const response = await service.getIssueById(id);
        return response.getResponseData() as IssuesApiResponse;
    }, [id, isRefecth]));

    // USE FETCH

    useEffect(() => {
        if (data) {
            const coordinates = data?.coordinates.split(',');
            setHuso(coordinates[0]);
            setCoordinatesX(coordinates[1]);
            setCoordinatesY(coordinates[2]);

            if (data?.species?.catAndalucia || data?.species?.catNacional) {
                setIsProtected(true);
            } else {
                setIsProtected(false);
            }

        }
    }, [data]);

    // RENDER 

    return (
        <div className="@container">
            <FormGroup
                title="Datos de la Incidencia"
                description='Información de la incidencia'
                className='pt-3 pb-4'
                titleCols="@md:col-span-12"
                childCols="@md:col-span-12 "
            >
                {userCan('list', 'companies') && (
                    <div className="grid md:grid-cols-1 grid-cols-1 gap-2" >
                        <Input
                            disabled
                            label="Compañia"
                            placeholder="Compañia"
                            value={data?.company?.name ?? ''}
                        />
                    </div>
                )}
                <div className={`grid ${isProtected ? 'md:grid-cols-3' : 'md:grid-cols-2'} grid-cols-1 gap-2`} >
                    <Input
                        disabled
                        label="Id"
                        placeholder="Id"
                        value={data?.id ?? ''}
                    />
                    <Input
                        disabled
                        label="Código"
                        placeholder="Código"
                        value={data?.issueCode ?? ''}
                    />
                    {isProtected && (
                        <Input
                            disabled
                            label="Identificador del agente"
                            placeholder="Identificador del agente"
                            value={data?.agentIdentifier ?? ''}
                        />)}
                </div>

                <div className="grid md:grid-cols-4 grid-cols-1 gap-2" >
                    <Input
                        disabled
                        label="Parque eólico"
                        placeholder="Parque"
                        value={data?.park?.name ?? ''}
                    />
                    <Input
                        disabled
                        label="Aerogenerador"
                        placeholder="Alias"
                        value={data?.windturbine?.alias ?? ''}
                    />
                    <Input
                        disabled
                        label="Especie afectada"
                        placeholder="Especie"
                        value={data?.species?.commonName ?? ''}
                        inputClassName="italic"
                    />
                    <Input
                        disabled
                        label="Observador"
                        placeholder="Observador"
                        value={(data?.user?.name ?? '') + ' ' + (data?.user?.lastName ?? '')}
                    />
                </div>

                <div className="grid md:grid-cols-3 grid-cols-1 gap-2" >
                    <Input
                        disabled
                        label="Dirección del viento"
                        placeholder="Dirección del viento"
                        value={
                            data?.windDirection
                                ? windDirectionsSpanish.find(option => option.value == data?.windDirection)?.label ?? 'sin datos'
                                : 'sin datos'
                        }
                    />
                    <Input
                        disabled
                        label="Intensidad del viento"
                        placeholder="Intensidad del viento"
                        value={
                            data?.windSpeed == 0 || data?.windSpeed != null
                                ? windSpeed.find(option => option.value == String(data?.windSpeed))?.label ?? 'sin datos'
                                : 'sin datos'
                        }
                    />
                    <Input
                        disabled
                        label="Cobertura de nubes"
                        placeholder="Cobertura de nubes"
                        value={
                            data?.cloudCoverage == 0 || data?.cloudCoverage != null
                                ? cloudCover.find(option => option.value == String(data?.cloudCoverage))?.label ?? 'sin datos'
                                : 'sin datos'
                        }
                    />
                </div>
                <div className="grid md:grid-cols-3 grid-cols-1 gap-2" >
                    <Input
                        disabled
                        label="Huso"
                        placeholder="Huso"
                        value={huso}
                    />
                    <Input
                        disabled
                        label="Coordenadas X"
                        placeholder="Coordenadas X"
                        value={coordinatesX}
                    />
                    <Input
                        disabled
                        label="Coordenadas Y"
                        placeholder="Coordenadas Y"
                        value={coordinatesY}
                    />
                </div>

                <div className="grid md:grid-cols-3 grid-cols-1 gap-2" >
                    <Input
                        disabled
                        label="Presencia de carroña"
                        placeholder="Presencia de carroña"
                        value={
                            data?.presenceCarrion
                                ? carrionPresentSelector.find(option => option.value == data?.presenceCarrion)?.label ?? 'Sin datos'
                                : 'Sin datos'
                        }
                    />
                    <Input
                        disabled
                        label="Edad del Ejemplar"
                        placeholder="Edad del Ejemplar"
                        value={data?.age
                            ? age.find(option => option.value == data?.age)?.label ?? 'Sin datos'
                            : 'Sin datos'
                        }
                    />
                    <Input
                        disabled
                        label="Sexo del Ejemplar"
                        placeholder="Sexo del Ejemplar"
                        value={data?.sex
                            ? sex.find(option => option.value == data?.sex)?.label ?? 'Sin datos'
                            : 'Sin datos'
                        }
                    />
                </div>

                <div className="grid md:grid-cols-3 grid-cols-1 gap-2" >
                    <Input
                        disabled
                        label="Estado del Ejemplar"
                        placeholder="Estado del Ejemplar"
                        value={data?.deadHurt
                            ? stateSpecies.find(option => option.value == data?.deadHurt)?.label ?? 'Sin datos'
                            : 'Sin datos'
                        }
                    />
                    <Input
                        disabled
                        label="Lesiones"
                        placeholder="Lesiones"
                        value={data?.injuries ?? 'Sin datos'}
                    />
                    <Input
                        disabled
                        label="Hábitat"
                        placeholder="Hábitat"
                        value={data?.habitat ?? 'Sin datos'}
                    />
                </div>

                <div className="grid md:grid-cols-1 grid-cols-1 gap-2" >
                    <Switch
                        id='stopNotified'
                        label="Parada notificada"
                        checked={data?.stopNotified ?? false}
                        className="mb-4"
                    />

                    <Switch
                        id='livestockPresence'
                        label="Presencia de ganado"
                        checked={data?.livestockPresence ?? false}
                        className="mb-4"
                    />

                    <Switch
                        id='triedToStop'
                        label="Intento hacer parada"
                        checked={data?.triedToStop ?? false}
                        className="mb-4"
                    />

                </div>


                <div className="grid md:grid-cols-2 grid-cols-1 gap-2" >
                    <Input
                        disabled
                        label="Fecha del Reporte"
                        placeholder="Reportado el"
                        value={data?.dateReported ?? ''}
                    />
                    <Input
                        disabled
                        label="Fecha estimada del accidente"
                        placeholder="Accidente el"
                        value={data?.dateEstimated ? moment(data?.dateEstimated.date).format('DD/MM/YYYY') : ''}
                    />
                </div>

                <div className="grid md:grid-cols-2 grid-cols-1 gap-2" >
                    <Input
                        disabled
                        label="Fecha de creación"
                        placeholder="Fecha de creación"
                        value={data?.createdAt ?? ''}
                    />
                    <Input
                        disabled
                        label="Fecha de ultima modificación"
                        placeholder="Ultima modificación"
                        value={data?.updatedAt ?? ''}
                    />
                </div>

                <div className="grid md:grid-cols-2 grid-cols-1 gap-2" >
                    <div className="flex flex-col mb-4">
                        <Input
                            disabled
                            label="Anillado"
                            value={
                                data?.anillado?.trim()
                                    ? yesNoSelector.find(option => option.value === 'yes')?.label
                                    : yesNoSelector.find(option => option.value === 'no')?.label
                            }
                        />
                        {data?.anillado?.trim() && (
                            <Textarea
                                id='anillado'
                                disabled
                                label='Detalles del anillado'
                                rows={6}
                                value={data?.anillado ?? ''}
                                className="mt-4"
                            />
                        )}
                    </div>

                    <Textarea
                        id='comments'
                        disabled
                        label='Observaciones'
                        rows={6}
                        value={data?.comments ?? ''}
                        className="mb-4"
                    />
                </div>

                {(data?.imageCoordinates !== null || isProtected) && (
                    <div className="grid md:grid-cols-12 grid-cols-1 gap-2" >
                        {data?.imageCoordinates !== null && (
                            <div className="col-12 md:col-span-6 flex flex-col">
                                <span className="rizzui-input-label block text-sm mb-1.5 font-medium">Imagen de la localización</span>
                                <img
                                    src={data?.imageCoordinates}
                                    alt="Imagen de la localización"
                                    className=""
                                />
                            </div>
                        )}
                        {isProtected && (
                            <>
                                {data?.imageCoordinates == null && (
                                    <div className="col-span-6"></div>
                                )}
                                <div className="col-12 md:col-span-3 flex flex-col">
                                    <span className="rizzui-input-label block text-sm mb-1.5 font-medium">Firma del técnico</span>
                                    <img
                                        src={data?.workerSignature}
                                        alt="Firma"
                                        className=""
                                    />
                                </div>
                                <div className="col-12 md:col-span-3 flex flex-col">
                                    <span className="rizzui-input-label block text-sm mb-1.5 font-medium">Firma AMA</span>
                                    <img
                                        src={data?.agentSignature}
                                        alt="Firma"
                                        className=""
                                    />
                                </div>
                            </>
                        )}
                    </div>
                )}


            </FormGroup>
        </div>
    )
}

export default IssuesInfo;